const t = {
  name: "Battery",
  dimensions: { width: 40, height: 22 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 22" style="enable-background:new 0 0 40 22;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M25,7v3h-3v2h3v3h2v-3h3v-2h-3V7H25z"/>
		<path class="st0" d="M13,10H5v2h8V10z"/>
		<path class="st0" d="M0,0h35v5h5v12h-5v5H0V0z M35,15h3V7h-3V15z M33,2H2v18h31V2z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as Battery
};
